import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";
import { useNavigate } from "react-router";

// Nepal Market logo supplied for the navbar.
const LogoImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURf/XAPak";

const LogoAnimation = () => {
  const navigate = useNavigate();
  const [playAnimation, setPlayAnimation] = useState(false);

  const [animation, setAnimation] = useSpring(() => ({
    from: { transform: "rotate(0deg) scale(0.2)" },
    to: [{ transform: "rotate(360deg) scale(1)" }],
    config: { mass: 1, tension: 120, friction: 20 },
    loop: false,
    reset: false,
    onRest: () => { setPlayAnimation(false); }
  }));

  useEffect(() => {
    if (playAnimation) {
      setTimeout(() => {
        setAnimation({ reset: true, loop: true, delay: 5000 });
      });
    }
  }, [playAnimation, setAnimation]);

  return (
    <div className="w-12 h-12 flex items-center justify-center">
      <button className="cursor-pointer" onClick={() => navigate("/")} aria-label="Nepal Market home">
        <animated.img
          style={animation}
          src={LogoImg}
          alt="Nepal Market"
          className="w-10 h-10 object-contain"
        />
      </button>
    </div>
  );
};

export default LogoAnimation;
